import './jquery';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'font-awesome/css/font-awesome.min.css';
import './sb-admin-2.min.css';



// WEBPACK FOOTER //
// ./src/include/bootstrap.js